import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { fetchSimilarMerchantsById } from 'core/actions/ocapi';
import { selectPageName } from 'core/selectors/app';
import List from 'core/modules/Partials/List/List';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import MerchantExperienceLink from 'core/modules/MerchantExperienceLink/MerchantExperienceLink';
import MerchantWithOfferCountTile from 'core/modules/MerchantWithOfferCountTile/MerchantWithOfferCountTile';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import MerchantTileList from 'core/modules/MerchantTileList/MerchantTileList';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import { triggerBecauseYouShoppedIsViewed }
  from 'core/modules/ForYou/components/BecauseYouShoppedForYou/analytics/types';
import {
  selectBecauseYouShoppedConfig,
  makeSelectBecauseYouShoppedSetOfMerchants,
  makeSelectBecauseYouShoppedSetIsLoading,
  makeSelectBecauseYouShoppedSetIsLoaded,
} from './selectors';

import './BecauseYouShopped.scss';

window.sectionsToShow = [];

function BecauseYouShopped({ merchantId, merchantName, useCarousel }) {
  const selectBecauseYouShoppedSetOfMerchants = makeSelectBecauseYouShoppedSetOfMerchants();
  const selectBecauseYouShoppedSetIsLoading = makeSelectBecauseYouShoppedSetIsLoading();
  const selectBecauseYouShoppedSetIsLoaded = makeSelectBecauseYouShoppedSetIsLoaded();

  const config = useSelector(selectBecauseYouShoppedConfig);
  const merchants = useSelector(state => selectBecauseYouShoppedSetOfMerchants(state, merchantId));
  const isLoading = useSelector(state => selectBecauseYouShoppedSetIsLoading(state, merchantId));
  const isLoaded = useSelector(state => selectBecauseYouShoppedSetIsLoaded(state, merchantId));
  const pageName = useSelector(selectPageName);
  const dispatch = useDispatch();

  const [, updateState] = useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const { sectionsToRender } = config;

  const { sectionsToShow } = window;

  const sectionTitle =
    <>Because you shopped <span className="mn_minor">at</span> {merchantName}<span className="mn_dot">.</span></>;

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      const { api: apiConfig } = config;
      const { params, options } = apiConfig;
      dispatch(fetchSimilarMerchantsById(merchantId, params, options));
    }
  }, []);

  useEffect(() => {
    if (pageName === 'foryou' && !isEmpty(merchants) && (window.sentGaBecauseYouShopped < sectionsToRender)) {
      window.sentGaBecauseYouShopped += 1;
      const merchantNames = merchants.map(a => a.name);
      dispatch(triggerBecauseYouShoppedIsViewed({ merchantNames, merchantName }));
    }
  }, [merchants]);

  useEffect(() => {
    if (!isEmpty(merchants) && sectionsToShow.length < sectionsToRender) {
      sectionsToShow.push(merchantId);
      forceUpdate();
    }
  }, [merchants]);

  if (isEmpty(merchants) || !sectionsToShow.includes(merchantId)) {
    return (null);
  }

  return (
    <div className="mn_becauseYouShopped">
      <ContentWrap>
        <SectionTitle title={sectionTitle} />
        {useCarousel ?
          <List options={config.carousel} shouldUseCarousel>
            {
              merchants.map(merchant => (
                <MerchantExperienceLink merchant={merchant} key={merchant.id}>
                  <MerchantWithOfferCountTile merchant={merchant} />
                </MerchantExperienceLink>
              ))
            }
          </List> :
          <MerchantTileList
            merchants={merchants}
            label="Extra"
          />
        }
      </ContentWrap>
    </div>
  );
}

export default (props) =>
  <ComponentErrorBoundary><BecauseYouShopped {...props} /></ComponentErrorBoundary>;
